import {
  BarChart3,
  Bell,
  Building2,
  Landmark,
  Package,
  Settings2,
  ShieldCheck,
  Tags,
  UserCheck,
  UserSearch,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * ADM — the ten things the back office does, in the order a person meets them.
 *
 * A tab strip was the obvious shape and does not survive a phone: ten tabs at
 * 375px are either unreadable or a horizontal scroll nobody discovers. So the
 * admin has a home screen of cards and each section is its own route — which is
 * also what gives every section a back button, a title of its own, and a URL
 * that can be sent to a colleague.
 */
export type SectionId =
  | 'notifications'
  | 'users'
  | 'approvals'
  | 'businesses'
  | 'packages'
  | 'staff'
  | 'leads'
  | 'trades'
  | 'clearing'
  | 'reports'
  | 'settings';

export const SECTIONS: Array<{ id: SectionId; icon: LucideIcon }> = [
  { id: 'notifications', icon: Bell },
  { id: 'approvals', icon: UserCheck },
  { id: 'leads', icon: UserSearch },
  { id: 'users', icon: Users },
  { id: 'businesses', icon: Building2 },
  { id: 'packages', icon: Package },
  { id: 'staff', icon: ShieldCheck },
  { id: 'trades', icon: Tags },
  { id: 'clearing', icon: Landmark },
  { id: 'reports', icon: BarChart3 },
  { id: 'settings', icon: Settings2 },
];

export const isSectionId = (value: string | undefined): value is SectionId =>
  SECTIONS.some((section) => section.id === value);
